import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IProducerStreamsCfg } from '../../Contract';
import { ProducerService } from '../../Producer.Service';
import { ProducerControlsService } from './ProducerControls.Service';

import styles from '../../ProducerSidebar.module.less';

@Component({
	selector: 'producer-controls-sidebar',
	templateUrl: './ProducerControlsSidebar.Component.html',
	host: {
		'[class]': 'styles.root'
	},
	standalone: false
})
export class ProducerControlsSidebarComponent implements OnInit, OnDestroy {
	public streams: IProducerStreamsCfg = {} as any;
	public camera: MediaDeviceInfo;
	public mic: MediaDeviceInfo;
	private readonly sub = new Subscription();
	public readonly styles = styles;
	public cameraAction: any;
	public micAction: any;

	constructor(
		private readonly ProducerControlsService: ProducerControlsService,
		private readonly ProducerService: ProducerService
	) { }

	public ngOnInit(): void {
		this.sub.add(this.ProducerService.producerStreams$.subscribe(streams => {
			this.streams = streams;
			this.resetSelection();
		}));
	}

	public ngOnDestroy(): void {
		this.sub.unsubscribe();
	}

	public resetSelection(): void {
		this.cameraAction = this.camera = this.streams.cameraLabel ?
			this.streams.cameraDevices.find(c => c.label === this.streams.cameraLabel) : undefined;
		this.micAction = this.mic = this.streams.micLabel ?
			this.streams.micDevices.find(m => m.label === this.streams.micLabel) : undefined;
	}

	public setCamera(action: any): void {
		if(!action) {
			setTimeout(() => this.resetSelection(), 100);
			return;
		}
		if(action === 'stop') {
			setTimeout(() => this.ProducerControlsService.stopCamera(), 100);
			return;
		}
		const camera = action === 'auto' ? null
			: action === 'start' ? this.camera
				: action;

		Promise.all([
			this.ProducerControlsService.startCamera(camera),
			!this.streams.micStream && this.ProducerControlsService.initMic(),
		])
			.catch(e => console.error('Error starting camera stream: ', e));
	}

	public setMic(action: any): void {
		if(!action) {
			setTimeout(() => this.resetSelection(), 100);
			return;
		}
		if(action === 'toggleMute') {
			setTimeout(() => {
				this.ProducerControlsService.toggleMic(
					this.streams.micMuted || !this.streams.micStream,
					this.streams.micDevice
				);
			}, 100);
			return;
		}
		const mic = action === 'auto' ? null : action;

		this.ProducerControlsService.toggleMic(true, mic);
	}
}
